import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError } from "components/Global/Toasts/Toasty";
import { downloadXLSFile } from "utils/api";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA = generateDefaultActions("REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA");
export const loanProceedsCalculatorResetTestData = payload => makePayload(REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA.value, payload);
function* loanProceedsCalculatorResetTestDataSaga(payload) {
  yield put(REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA.createSuccess(payload));
}

export const REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS = generateDefaultActions("REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS");
export const getLoanProceedAssumptions = payload => makePayload(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.value, payload);
function* getLoanProceedAssumptionsSaga(payload) {
  const url = "/loan/getLoanProceedAssumptions";
  yield requestSaga(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS, url, "POST", payload);
}

export const REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID = generateDefaultActions("REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID");
export const getLoanProceedAssumptionsByDealId = payload => makePayload(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, payload);
function* getLoanProceedAssumptionsByDealIdSaga(payload) {
  const url = "/loan/getLoanProceedAssumptionsByDealId";
  yield requestSaga(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID, url, "POST", payload);
}

export const REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS = generateDefaultActions("REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS");
export const getDealPropertyProjections = payload => makePayload(REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.value, payload);
function* getDealPropertyProjectionsSaga(payload) {
  const url = `/getDealPropertyProjections/${payload.dealId}`;
  yield requestSaga(REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS, url);
}

export const REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT = generateDefaultActions("REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT");
export const calculateLoanProceeds = payload => makePayload(REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT.value, payload);
function* calculateLoanProceedsSaga(payload) {
  const url = "/metrics/dealCashOutAnalysis";
  yield requestSaga(REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT, url, "POST", payload);
  if (payload.callback) {
    payload.callback();
  }
}

// NOTE: this was not referenced in the reducer!
export const REFI_CASHOUT_CALCULATOR_DOWNLOAD_CASH_OUT = generateDefaultActions("REFI_CASHOUT_CALCULATOR_DOWNLOAD_CASH_OUT");
export const downloadLoanProceeds = payload => makePayload(REFI_CASHOUT_CALCULATOR_DOWNLOAD_CASH_OUT.value, payload);
function* downloadLoanProceedsSaga(payload) {
  try {
    yield call(downloadXLSFile, "downloadCashOutAnalysis", "POST", payload);
  } catch (error) {
    yield put(REFI_CASHOUT_CALCULATOR_DOWNLOAD_CASH_OUT.createFailure(error));
  }
}

// REDUCER

const initialState = {
  loanProceedAssumptions: null,
  consolidatedProjections: null,
  loanProceeds: null,
  cashOutResult: null,
  dealPropertyProjections: null
};

export function refiCashoutCalculatorReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA.success:
      return {
        ...state,
        ...initialState
      };

    case REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.success:
      return defaultReturn(state, payload.data, "loanProceedAssumptions");

    case REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.success:
      const loanProceedAssumptions = payload.data ? payload.data[0] : "Not Set";

      return defaultReturn(state, loanProceedAssumptions, "loanProceedAssumptionsForDeal");

    case REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.success:
      const consolidatedProjections = payload && payload.result && payload.result.consolidatedProjections ? payload.result.consolidatedProjections : {};

      return defaultReturn(state, consolidatedProjections, "dealPropertyProjections");

    case REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT.success:
      payload.success = true;

      return defaultReturn(state, payload.result, "cashOutResult");

    case REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT.failure:
      payload.success = false;
      ToastError(payload.result);

      return defaultReturn(state, payload, "cashOutResult");

    default:
      return state;
  }
}

// SAGA

export function* refiCashoutCalculatorSaga() {
  yield takeLatest(REFI_CASHOUT_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.value, getDealPropertyProjectionsSaga);
  yield takeLatest(REFI_CASHOUT_CALCULATOR_RESET_TEST_DATA.value, loanProceedsCalculatorResetTestDataSaga);
  yield takeLatest(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.value, getLoanProceedAssumptionsSaga);
  yield takeLatest(REFI_CASHOUT_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, getLoanProceedAssumptionsByDealIdSaga);
  yield takeLatest(REFI_CASHOUT_CALCULATOR_CALCULATE_CASH_OUT.value, calculateLoanProceedsSaga);
  yield takeLatest(REFI_CASHOUT_CALCULATOR_DOWNLOAD_CASH_OUT.value, downloadLoanProceedsSaga);
}
